/** Tipos e helpers da Icon Library (painel + público). */

export type IconRenderMode = 'mask' | 'img';

export type IconLibraryCategory = {
  id: string;
  label: string;
};

export type IconLibraryItem = {
  id: number;
  name: string;
  slug: string;
  category: string;
  description: string | null;
  tags: string[];
  renderMode: IconRenderMode;
  url: string;
  svgContent?: string;
  createdAt: string | null;
  updatedAt: string | null;
};

export type IconLibraryPayload = {
  name: string;
  slug?: string;
  category?: string;
  svgContent: string;
  description?: string | null;
  tags?: string[] | string | null;
  renderMode?: IconRenderMode;
};

export const ICON_LIBRARY_CATEGORIES: IconLibraryCategory[] = [
  { id: 'interface', label: 'Interface' },
  { id: 'navegacao', label: 'Navegação' },
  { id: 'guias', label: 'Guias' },
  { id: 'powers', label: 'Powers' },
  { id: 'aces', label: 'Aces' },
  { id: 'sistema', label: 'Sistema' },
  { id: 'social', label: 'Social' },
  { id: 'pstyle', label: 'Pstyle' },
  { id: 'outros', label: 'Outros' },
];

export const ICON_LIBRARY_PREFIX = 'library:';

export function isLibraryIconRef(value: string): boolean {
  return value.trim().toLowerCase().startsWith(ICON_LIBRARY_PREFIX);
}

export function libraryIconSlug(value: string): string | null {
  const v = value.trim();
  if (!isLibraryIconRef(v)) return null;
  const slug = v.slice(ICON_LIBRARY_PREFIX.length).trim();
  return slug || null;
}

export function toLibraryIconRef(slug: string): string {
  return `${ICON_LIBRARY_PREFIX}${slug.trim()}`;
}

export function categoryLabel(id: string): string {
  return ICON_LIBRARY_CATEGORIES.find((c) => c.id === id)?.label ?? id;
}

export function slugifyIconName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Detecção básica de conteúdo perigoso no cliente (aviso; o servidor sanitiza). */
export function detectDangerousSvgHints(svg: string): string[] {
  const hints: string[] = [];
  if (/<script\b/i.test(svg)) hints.push('Contém <script>.');
  if (/\son[a-z]+\s*=/i.test(svg)) hints.push('Contém event handlers (on*).');
  if (/javascript:/i.test(svg)) hints.push('Contém javascript: URLs.');
  if (/<foreignObject\b/i.test(svg)) hints.push('Contém <foreignObject>.');
  if (/<(iframe|embed|object)\b/i.test(svg)) hints.push('Contém embeds/iframes.');
  return hints;
}
